; !function (w) {
  var plugin = {
    ajax: function (url, data) {
      // 根据域名区分环境
      // var	api = 'https://testapi.patozon.net/'
      // var api = 'https://testapidev.patozon.net/'
      // data.app_env = 'sandbox';
      // var api = 'https://release-api.patozon.net/'
      var api = 'https://brand-api.patozon.net/'
      // 判断是否有http 有我就不加上前面域名
      if (url.indexOf('http') < 0) {
        url = api + url;
      }
      // 设置品牌id
      data.store_id = 1;
      data.client_access_url = window.location.href;
      
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: url,
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(data),
          dataType: "json",
          success: function (res) {
            resolve(res)
          },
          error: err => {
            reject(err)
          }
        })
      })
    },
    shopiyfRegister: function (url, data) {
      let that = this
      let result = data
      return new Promise((resolve, reject) => {
        that.ajax(url, data).then(res => {
          if (res.code == 1) {
            console.log(result)
            // 调用shopiyf的登录接口
            let loginUrl = '/account/login'
            var data = {
              'customer[email]': result.account,
              'customer[password]': result.password,
              form_type: 'customer_login',
              utf8: '✓'
            }
            $.ajax({
              url: loginUrl,
              method: 'post',
              data: data,
              dataType: 'html',
              async: false,
              complete: function (response) {
                resolve(response)
              }
            });
          } else {
            reject(res)
          }
        })
      })
    },
    registerShopify: function (data) {
      let result = data
      return new Promise((resolve, reject) => {
        // 调用shopiyf的登录接口
        let loginUrl = '/account'
        let data = {
          'customer[email]': result.account,
          'customer[password]': result.password,
          'customer[first_name]': result.first_name,
          'customer[last_name]': result.last_name,
          'return_to': 'pages/blank',
          form_type: 'create_customer',
          utf8: '✓'
        }
        $.ajax({
          url: loginUrl,
          method: 'post',
          data: data,
          dataType: 'html',
          async: false,
          complete: function (response) {
            resolve(response)
          },
          // error: function (err) {
          //   reject(err)
          // }
        })
      })
    },
    shopiyfLogin: function (data) {
      let result = data
      return new Promise((resolve, reject) => {
        // 调用shopiyf的登录接口
        let loginUrl = '/account/login'
        let data = {
          'customer[email]': result.account,
          'customer[password]': result.password,
          form_type: 'customer_login',
          utf8: '✓'
        }
        $.ajax({
          url: loginUrl,
          method: 'post',
          data: data,
          dataType: 'html',
          async: false,
          complete: function (response) {
            resolve(response)
          },
          error: function(err) {
            reject(err)
          }
        })
      })
    },
    isExistDate: function (dateStr) { // yyyy/mm/dd
      const dateObj = dateStr.split('-');
      //列出12個月，每月最大日期限制
      const limitInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      const theYear = parseInt(dateObj[0]);
      const theMonth = parseInt(dateObj[1]);
      const theDay = parseInt(dateObj[2]);
      const isLeap = new Date(theYear, 1, 29).getDate() === 29; // 是否為閏年?

      if (isLeap) { // 若為閏年，最大日期限制改為 29
        limitInMonth[1] = 29;
      }

      // 比對該日是否超過每個月份最大日期限制
      return theDay <= limitInMonth[theMonth - 1]
    },
    isMobile: function () { //判断终端是否是手机
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      return Agents.some(function (item) {
        return userAgentInfo.indexOf(item) > 0
      });
    },
    getQuerysString: function() { //获取url中"?"符后的字串 
      var url = location.search; 
      var theRequest = new Object(); 
      if (url.indexOf("?") != -1) { 
        var str = url.substr(1); 
        strs = str.split("&"); 
        for(var i = 0; i < strs.length; i ++) { 
          theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1] || ''); 
        } 
      } 
      return theRequest; 
    },
    /**
      * 登录报告接口
      */
    getLoginReport: function(data) { //获取url中"?"符后的字串 
      var url = 'api/statistical/report';
      return this.ajax(url, data)
    }
  }
  w.plugin = plugin;
}(window);